import React from "react";

export interface CookingInstructionsFocusContextValue {
    isCookingInstructionsFocused: boolean;
    setCookingInstructionsFocused: (focused: boolean) => void;
    /** for jiohotstar flow, scroll the clicked cooking-instructions UI into view  */
    scrollCookingInstructionsOnClick: (element: HTMLElement) => void;
}

export const CookingInstructionsFocusContext = React.createContext<CookingInstructionsFocusContextValue>({
    isCookingInstructionsFocused: false,
    setCookingInstructionsFocused: () => {
        // no-op default
    },
    scrollCookingInstructionsOnClick: () => {
        // no-op default
    },
});

if (__DEV__) {
    CookingInstructionsFocusContext.displayName = "CookingInstructionsFocusContext";
}
